import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        name: 'home',
        redirect: '/gym',
        meta: {
            title: '首页',
            renderMenu: false,
            icon: 'HomeOutlined',
        },
    },

    {
        path: '/order',
        name: 'order',
        meta: {
            title: '订单',
            renderMenu: true,
            icon: 'ShoppingCartOutlined'
        },
        children: [
            {
                path: '/cardOrder',
                name: 'cardOrder',
                meta: {
                    title: '健身卡订单',
                    renderMenu: true,
                    icon: 'CreditCardOutlined'
                },
                component: () => import('@/pages/CardOrder.vue'),
                children: [

                ]
            },
            {
                path: '/lessonOrder',
                name: 'lessonOrder',
                meta: {
                    title: '私教订单',
                    renderMenu: true,
                    icon: 'SolutionOutlined'
                },
                component: () => import('@/pages/LessonOrder.vue'),
                children: []
            },
            {
                path: '/productOrder',
                name: 'productOrder',
                meta: {
                    title: '商城订单',
                    renderMenu: true,
                    icon: 'ShoppingOutlined'
                },
                component: () => import('@/pages/ProductOrder.vue'),
                children: []
            },
            {
                path: '/groupOrder',
                name: 'groupOrder',
                meta: {
                    title: '购订单',
                    renderMenu: true,
                    icon: 'TeamOutlined'
                },
                component: () => import('@/pages/GroupOrder.vue'),
                children: []
            },
        ]
    },
    {
        path: '/memberManagement',
        name: 'memberManagement',
        meta: {
            title: '会员管理',
            renderMenu: true,
            icon: 'UserOutlined'
        },
        children: [
            {
                path: '/member',
                name: 'member',
                meta: {
                    title: '会员',
                    renderMenu: true,
                    icon: 'UserOutlined'
                },
                component: () => import('@/pages/Member.vue'),
                children: []
            },
            {
                path: '/record',
                name: 'record',
                meta: {
                    title: '健身记录',
                    renderMenu: true,
                    icon: 'BarChartOutlined'
                },
                component: () => import('@/pages/Record.vue'),
                children: []
            },
            {
                path: '/test',
                name: 'test',
                meta: {
                    title: '体测记录',
                    renderMenu: true,
                    icon: 'LineChartOutlined'
                },
                component: () => import('@/pages/BodyTest.vue'),
                children: []
            },
            {
                path: '/tag',
                name: 'tag',
                meta: {
                    title: '会员标签',
                    renderMenu: true,
                    icon: 'TagOutlined'
                },
                component: () => import('@/pages/Tag.vue'),
                children: []
            },
        ]
    },
    {
        path: '/couponManagement',
        name: 'couponManagement',
        meta: {
            title: '优惠券管理',
            renderMenu: true,
            icon: 'GiftOutlined'
        },
        children: [
            {
                path: '/couponRecord',
                name: 'couponRecord',
                meta: {
                    title: '优惠券记录',
                    renderMenu: true,
                    icon: 'GiftOutlined'
                },
                component: () => import('@/pages/CouponRecord.vue'),
                children: []
            },
            {
                path: '/coupon',
                name: 'coupon',
                meta: {
                    title: '优惠券',
                    renderMenu: true,
                    icon: 'GiftOutlined'
                },
                component: () => import('@/pages/Coupon.vue'),
                children: []
            },
            {
                path: '/poster',
                name: 'poster',
                meta: {
                    title: '海报',
                    renderMenu: true,
                    icon: 'PictureOutlined'
                },
                component: () => import('@/pages/Poster.vue'),
                children: []
            },
        ]
    },
    {
        path: '/privateCoach',
        name: 'privateCoach',
        meta: {
            title: '私教管理',
            renderMenu: true,
            icon: 'SolutionOutlined'
        },
        children: [
            {
                path: '/lessonRecord',
                name: 'lessonRecord',
                meta: {
                    title: '私教记录',
                    renderMenu: true,
                    icon: 'FileTextOutlined'
                },
                component: () => import('@/pages/LessonRecord.vue'),
                children: []
            },
            {
                path: '/program',
                name: 'program',
                meta: {
                    title: '私教项目',
                    renderMenu: true,
                    icon: 'BookOutlined'
                },
                component: () => import('@/pages/Program.vue'),
                children: []
            },
            {
                path: '/coach',
                name: 'coach',
                meta: {
                    title: '教练',
                    renderMenu: true,
                    icon: 'UsergroupAddOutlined'
                },
                component: () => import('@/pages/Coach.vue'),
                children: []
            },
        ]
    },
    {
        path: '/gymManagement',
        name: 'gymManagement',
        meta: {
            title: '健身房管理',
            renderMenu: true,
            icon: 'ShopOutlined'
        },
        children: [
            {
                path: '/gym',
                name: 'gym',
                meta: {
                    title: '健身房',
                    renderMenu: true,
                    icon: 'ShopOutlined'
                },
                component: () => import('@/pages/Gym.vue'),
                children: []
            },
            {
                path: '/card',
                name: 'card',
                meta: {
                    title: '健身卡',
                    renderMenu: true,
                    icon: 'IdcardOutlined'
                },
                component: () => import('@/pages/Card.vue'),
                children: []
            },
            {
                path: '/deviceRelationship',
                name: 'deviceRelationship',
                meta: {
                    title: '设备关系',
                    renderMenu: true,
                    icon: 'LinkOutlined'
                },
                component: () => import('@/pages/DeviceRelationship.vue'),
                children: []
            },
            {
                path: '/device',
                name: 'device',
                meta: {
                    title: '设备',
                    renderMenu: true,
                    icon: 'ToolOutlined'
                },
                component: () => import('@/pages/Device.vue'),
                children: []
            },
            {
                path: '/wall',
                name: 'wall',
                meta: {
                    title: '照片墙审核',
                    renderMenu: true,
                    icon: 'CameraOutlined'
                },
                component: () => import('@/pages/Wall.vue'),
                children: []
            },
            {
                path: '/music',
                name: 'music',
                meta: {
                    title: '音乐',
                    renderMenu: true,
                    icon: 'CustomerServiceOutlined'
                },
                component: () => import('@/pages/Music.vue'),
                children: []
            },
        ]
    },

    {
        path: '/game',
        name: 'game',
        meta: {
            title: '比赛',
            renderMenu: true,
            icon: 'TrophyOutlined'
        },
        children: [
            {
                path: '/gameDetail',
                name: 'gameDetail',
                meta: {
                    title: '比赛',
                    renderMenu: true,
                    icon: 'TrophyOutlined'
                },
                component: () => import('@/pages/Game.vue'),
                children: [

                ]
            },
            {
                path: '/gameRound',
                name: 'gameRound',
                meta: {
                    title: '一局比赛',
                    renderMenu: true,
                    icon: 'ReconciliationOutlined'
                },
                component: () => import('@/pages/GameRound.vue'),
                children: []
            },
            {
                path: '/gameRecord',
                name: 'gameRecord',
                meta: {
                    title: '比赛记录',
                    renderMenu: true,
                    icon: 'HistoryOutlined'
                },
                component: () => import('@/pages/GameRecord.vue'),
                children: []
            },
        ]
    },
    {
        path: '/cost',
        name: 'cost',
        meta: {
            title: '费用',
            renderMenu: true,
            icon: 'DollarCircleOutlined'
        },
        component: () => import('@/pages/Cost.vue'),
        children: []
    },
    {
        path: '/place',
        name: 'place',
        meta: {
            title: '空间',
            renderMenu: true,
            icon: 'EnvironmentOutlined'
        },
        component: () => import('@/pages/Place.vue'),
        children: []
    },
    {
        path: '/supplier',
        name: 'supplier',
        meta: {
            title: '供应商',
            renderMenu: true,
            icon: 'DeliveredProcedureOutlined'
        },
        component: () => import('@/pages/Supplier.vue'),
        children: []
    },
    {
        path: '/gift',
        name: 'gift',
        meta: {
            title: '礼品',
            renderMenu: true,
            icon: 'GiftOutlined'
        },
        component: () => import('@/pages/Gift.vue'),
        children: []
    },
    {
        path: '/product',
        name: 'product',
        meta: {
            title: '商品',
            renderMenu: true,
            icon: 'ShoppingOutlined'
        },
        component: () => import('@/pages/Product.vue'),
        children: []
    },
    {
        path: '/group',
        name: 'group',
        meta: {
            title: '团购',
            renderMenu: true,
            icon: 'TeamOutlined'
        },
        component: () => import('@/pages/Group.vue'),
        children: []
    },
    {
        path: '/iot',
        name: 'iot',
        meta: {
            title: '物联网',
            renderMenu: true,
            icon: 'CloudOutlined'
        },
        children: [
            {
                path: '/IOTProduct',
                name: 'IOTProduct',
                meta: {
                    title: '产品',
                    renderMenu: true,
                    icon: 'AppstoreOutlined'
                },
                component: () => import('@/pages/AliyunIOTProduct.vue'),
                children: []
            },
            {
                path: '/IOTDevice',
                name: 'IOTDevice',
                meta: {
                    title: '设备',
                    renderMenu: true,
                    icon: 'GatewayOutlined'
                },
                component: () => import('@/pages/AliyunIOTDevice.vue'),
                children: [

                ]
            },
            {
                path: '/tuyaProduct',
                name: 'tuyaProduct',
                meta: {
                    title: '涂鸦产品',
                    renderMenu: true,
                    icon: 'AppstoreOutlined'
                },
                component: () => import('@/pages/TuyaIOTProduct.vue'),
                children: []
            },
            {
                path: '/tuyaDevice',
                name: 'tuyaDevice',
                meta: {
                    title: '涂鸦设备',
                    renderMenu: true,
                    icon: 'GatewayOutlined'
                },
                component: () => import('@/pages/TuyaIOTDevice.vue'),
                children: [

                ]
            },
        ]
    },
    {
        path: '/setting',
        name: 'setting',
        meta: {
            title: '设置',
            renderMenu: true,
            icon: 'SettingOutlined'
        },
        component: () => import('@/pages/Setting.vue'),
        children: []
    },
    {
        path: '/front',
        name: '前端',
        meta: {
            renderMenu: false,
            icon: 'DesktopOutlined',
        },
        component: () => import('@/components/layout/FrontView.vue'),
        children: [
            {
                path: '/login',
                name: '登录',
                meta: {
                    icon: 'LoginOutlined',
                    view: 'blank',
                    target: '_blank',
                    cacheable: false,
                },
                component: () => import('@/pages/login'),
            },
            {
                path: '/gym',
                name: '首页',
                meta: {
                    view: 'blank',
                },
                component: () => import('@/pages/Gym.vue'),
            },
        ],
    },
    {
        path: '/403',
        name: '403',
        props: true,
        meta: {
            renderMenu: false,
        },
        component: () => import('@/pages/Exp403.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: '404',
        props: true,
        meta: {
            icon: 'QuestionCircleOutlined',
            renderMenu: false,
            cacheable: false,
            _is404Page: true,
        },
        component: () => import('@/pages/Exp404.vue'),
    },
]

export default routes
